import { render, staticRenderFns } from "./ItemsMasterList.vue?vue&type=template&id=04614de8&scoped=true&"
import script from "./ItemsMasterList.vue?vue&type=script&lang=js&"
export * from "./ItemsMasterList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsMasterList.vue?vue&type=style&index=0&id=04614de8&prod&lang=scss&scoped=true&"
import style1 from "./ItemsMasterList.vue?vue&type=style&index=1&id=04614de8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04614de8",
  null
  
)

export default component.exports